import React from "react";
import { useTranslation } from 'react-i18next'; // AJOUT
import '../../CSS/Equipe_diplomatique.css';
import AmbassadorSection from "../composant_reutilisable/AmbassadorSection";
import Membre_equipe_diplo from "../composant_reutilisable/membre_equipe_diplo";
import AncienAmbassadorSection from "../composant_reutilisable/AncienAmbassadorSection";

const Equipe_diplomatique = () => {
    const { t } = useTranslation(); // AJOUT: Hook de traduction
    
    return (
        <div className="Equipe_diplomatique-container mt-4">
            <div className="Equipe_diplomatique-content">
                <AmbassadorSection/>
                <h1 className="equipe_diplo_h2">{t('equipeDiplomatique.title')}</h1>
                <Membre_equipe_diplo/>
                {/* <AncienAmbassadorSection/> */}
            </div>
        </div>
    );
};

export default Equipe_diplomatique;